import React from 'react';
import PropTypes from 'prop-types';

import Pill from 'components/Pill';
import { bem } from 'helpers/class-name';

import './PillGroup.scss';

const { block, element } = bem('pill-group');

const HTML_TAG_BUTTON = 'button';
const HTML_TYPE_BUTTON = 'button';
const PILL_THEME_LIGHT = 'light';

function formatOptionLabel(label, count) {
  if (count == null) {
    return label;
  }

  return `${label} (${count})`;
}

function PillGroup({ className, options, value, onChange, ...rest }) {
  return (
    <div {...rest} className={block(className)} role="group">
      {options.map(({ key, label, count, disabled }) => {
        const isActive = key === value;
        const isDisabled = Boolean(disabled);

        return (
          <Pill
            key={key}
            className={element('pill')}
            tagName={HTML_TAG_BUTTON}
            type={HTML_TYPE_BUTTON}
            theme={PILL_THEME_LIGHT}
            active={isActive}
            disabled={isDisabled}
            aria-pressed={isActive}
            onClick={isDisabled ? undefined : () => onChange(key)}>
            {formatOptionLabel(label, count)}
          </Pill>
        );
      })}
    </div>
  );
}

PillGroup.defaultProps = {
  options: [],
};

PillGroup.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      disabled: PropTypes.bool,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PillGroup;
